import React from "react";
const PaymentMethodCell = ({ method }) => {
  return (
    <td className="border border-slate-200 px-4 py-3">
      <div className="flex items-center space-x-2">
        <span className="text-lg">{method.logo}</span>
        <span className="font-medium text-slate-700">{method.name}</span>
      </div>
    </td>
  );
};

export default PaymentMethodCell;
